import React, { useEffect, useState } from "react";
import "./plan-message-display.scss";
import { interpolateMessage } from "../../util/message-interpolation";
import { useSelector } from "../../store/store";
import { get } from "../../repositories/participant";

const PATHS_FOR_MESSAGES = [
  "overview",
  "contribution",
  "distribution",
  "investment",
  "statement",
  "beneficiaries",
  "dashboard",
  "plan-overview",
  "planHistory",
  "personal-details",
  "plan-info",
  "contributions/summary",
  "balances-by-source",
  "distributions/summary",
  "investments/summary",
  "manage",
  "transfer",
  "invDirection",
  "investment-allocation",
  "research",
];

export default function PlanMessageDisplay() {
  const { planId, empId, role } = useSelector((state) => state.session);
  const { contractId } = useSelector((state) => state.plan.info);
  const [filteredPlanMessages, setFilteredPlanMessages] = useState([]);
  const [planMessages, setPlanMessages] = useState([]);

  useEffect(() => {
    async function fetchMessages() {
      if (planId && empId && role) {
        try {
          const messageData = await get(
            `/plans/${planId}/employees/${empId}/messages`,
            {
              role,
            }
          );
          setPlanMessages(messageData);

          const filteredMessageData = filterPlanMessages(
            window.location.pathname,
            messageData
          );
          setFilteredPlanMessages(filteredMessageData);
        } catch (e) {
          console.error("Error fetching plan messages:", e);
          setFilteredPlanMessages([]);
        }
      } else {
        setFilteredPlanMessages([]);
      }
    }

    fetchMessages();
  }, [empId, planId, role]);

  return (
    <div id="plan-messages">
      {filteredPlanMessages && filteredPlanMessages.length > 0 && (
        <div className="alert theme-banner theme-banner-info util-margin-bottom-0">
          <section className={"container no-print"}>
            {filteredPlanMessages.map((planMessage, index) =>
              displayMessage(planMessage, index, contractId, planId, empId)
            )}
          </section>
        </div>
      )}
    </div>
  );
}

export function filterPlanMessages(selectedPath, planMessages) {
  // This is used to include the invDirection page with investment plan messages which is a contribution page but needs to count for investment pages
  if (planMessages) {
    const hasInvestmentPage = planMessages.some((planMessage) => {
      return planMessage.messagePageTarget?.includes("investment");
    });
    const messagePaths = PATHS_FOR_MESSAGES.filter((path) => {
      return (
        selectedPath.includes(path) ||
        (selectedPath.includes("invDirection") &&
          hasInvestmentPage &&
          path.includes("invDirection"))
      );
    });
    return planMessages.filter((planMessage) => {
      const showOnPage = messagePaths.includes(planMessage.messagePageTarget);
      const showOnFutureAllocations =
        messagePaths.includes("invDirection") &&
        planMessage.messagePageTarget === "investment";
      const showEverywhere =
        planMessage.messagePageTarget === "all" ||
        planMessage.messageName === "GLOBAL";
      return showOnPage || showEverywhere || showOnFutureAllocations;
    });
  } else {
    return [];
  }
}

function displayMessage(planMessage, index, contractId, planId, empId) {
  let message = planMessage.subHeader;
  message = interpolateMessage(message, contractId, planId, empId);
  return (
    <div key={index} className="plan-message" data-testid="message">
      <h4>{planMessage.header}</h4>
      <div
        data-testid={"message-" + index}
        key={"planMessage" + index}
        dangerouslySetInnerHTML={{ __html: message }}
      ></div>
      <hr className="separator" />
    </div>
  );
}
